import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';

export default class Status extends React.Component<GridCustomCellProps> {
  render() {
    if (!this.props.field) return null;

    return (
      <td {...this.props.tdProps} style={{ color: this.props.dataItem.StatusColor }}>
        {this.props.dataItem.Status}
      </td>
    );
  }

  public shouldComponentUpdate(nextProps: GridCustomCellProps) {
    return nextProps.dataItem.Hash !== this.props.dataItem.Hash;
  }
}
